import NotificationsPage from "pages/notifications/Notifications";
import { Route } from "react-router-dom";

const routes = {
  key: "NOTIFICATIONS",
  routes: ({ userScope }) => [
    <Route
      key="notifications"
      path={`${userScope}/notifications`}
      element={<NotificationsPage />}
    />,
  ],
};
export default routes;
